<template>
  <div
    class="column"
    :class="{
      'column--disabled': disabled,
    }"
  >
    <label class="item" @click="onClick">
      <div
        class="item-checkbox"
        :class="{
          'item-checkbox_check': checked.toString() === '1',
          'item-checkbox_half': checked.toString() === '2',
        }"
      >
        <svg
          class="item-checkbox-value item-checkbox-value_check"
          width="11"
          height="8"
          viewBox="0 0 11 8"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.29312 7.6838C2.90259 7.29327 2.90259 6.66011 3.29312 6.26958L8.29712 1.26555C8.68764 0.875025 9.32081 0.875025 9.71133 1.26555C10.1019 1.65607 10.1019 2.28924 9.71133 2.67976L4.70733 7.6838C4.31681 8.07432 3.68364 8.07432 3.29312 7.6838Z"
          />
          <path
            d="M4.70733 7.6838C5.09786 7.29327 5.0978 6.66011 4.70727 6.26958L1.73445 3.29679C1.34393 2.90626 0.710761 2.90626 0.320237 3.29679C-0.0702873 3.68731 -0.0702873 4.32048 0.320237 4.711L3.29312 7.6838C3.68364 8.07432 4.31681 8.07432 4.70733 7.6838Z"
          />
        </svg>

        <div class="item-checkbox-value item-checkbox-value_square"></div>
      </div>

      <div class="item-label" v-html="name"></div>
    </label>
  </div>
</template>

<script>
export default {
  props: ["name", "checked", "disabled"],
  methods: {
    onClick() {
      if (this.disabled) return;
      this.$emit("toggle", !this.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.column {
  margin-bottom: 20px;

  .item {
    display: flex;
    cursor: pointer;
    margin-bottom: 0;

    &-toggle {
      display: none;
    }

    &-checkbox {
      position: relative;
      border: 1px solid $color-border;
      width: 18px;
      height: 18px;
      border-radius: 3px;
      transition: 0.2s;
      flex-shrink: 0;

      &_check,
      &_half {
        border: 1px solid $color-primary;
        background: $color-primary;
      }

      &_check {
        .item-checkbox-value_check {
          visibility: visible;
          opacity: 1;
        }
      }

      &_half {
        .item-checkbox-value_square {
          visibility: visible;
          opacity: 1;
        }
      }

      &-value {
        position: absolute;
        top: 50%;
        left: 50%;
        transition: 0.2s;
        visibility: hidden;
        opacity: 0;

        &_check {
          margin-left: -5px;
          margin-top: -4px;
          fill: white;
        }

        &_square {
          width: 6px;
          height: 6px;
          border-radius: 1px;
          margin-top: -3px;
          margin-left: -3px;
          background: white;
        }
      }
    }

    &-label {
      font-size: 13px;
      margin-left: 10px;
    }
  }

  &--disabled {
    .item {
      opacity: 0.5;
      cursor: default;
    }
  }

  @media screen and (max-width: 700px) {
    .item {
      width: 100%;
      padding: 0 20px;

      &-label {
        flex-grow: 1;
      }

      &-toggle {
        display: flex;
        width: 22px;
        height: 22px;
        border: 1px solid $color-border-light;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        transform: rotate(180deg);
        transition: 0.2s;
      }
    }
  }
}
</style>
